import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import http from '@lib/http-client'
import {
  CompanyListItem,
  CompanyMemberItem,
  CompanyMembersResponse,
  FetchCompanyMembersParams,
  MembersStore
} from './types'

export type {
  CompanyListItem,
  CompanyMemberItem,
  CompanyMembersResponse,
  FetchCompanyMembersParams,
  MembersStore
}

/* -----------------------------------------------------------------------------
 * store
 * -------------------------------------------------------------------------- */

export const useMembersStore = create<MembersStore>()(
  devtools(() => ({
    fetchCompaniesList: async () => {
      try {
        const response = await http.get('/professional/members_by_company')
        return (response as CompanyListItem[]) || []
      } catch (error) {
        console.error('Error fetching companies list:', error)
        return []
      }
    },

    fetchCompanyMembers: async (companyId, params = {}) => {
      try {
        const qs = new URLSearchParams()
        if (params.order_by) qs.append('order_by', params.order_by)
        if (params.page != null) qs.append('page', String(params.page))
        if (params.page_size != null)
          qs.append('page_size', String(params.page_size))
        if (params.last_engagement && params.last_engagement.length > 0) {
          qs.append('last_engagement', params.last_engagement.join(','))
        }
        const queryString = qs.toString()
        const path = `/professional/dashboard_members_by_company/${companyId}${
          queryString ? `?${queryString}` : ''
        }`

        const response = await http.get(path)
        return (response as CompanyMembersResponse) || null
      } catch (error) {
        console.error('Error fetching company members:', error)
        return null
      }
    }
  }))
)
